export default {
  placeholder: 'Select job statuses',
};
